module.exports = __webpack_public_path__ + "img/icon-instagram.2c243ad6.svg";